export const PLACEHOLDER_TYPES = {
  FIELD: 'field',
  MANUAL: 'manual',
  OPTIONAL: 'optional',
  TABLE: 'table',
  MAP: 'map',
  IMAGE: 'image',
  CHART: 'chart',
  CAPTION: 'caption',
};

export const buildFieldPlaceholder = (token) => `{{${token}}}`;

export const buildManualPlaceholder = (label) => `[MANUAL: ${label}]`;

export const buildOptionalPlaceholder = (label) => `[OPTIONAL: ${label}]`;

export const buildTablePlaceholder = (label) => `[TABLE: ${label}]`;

export const buildMapPlaceholder = (label) => `[MAP: ${label}]`;

export const buildImagePlaceholder = (label) => `[IMAGE: ${label}]`;

export const buildChartPlaceholder = (label) => `[CHART: ${label}]`;

export const buildCaptionPlaceholder = (label) => `[CAPTION: ${label}]`;

export const createTemplatePlaceholders = (t) => ({
  field: (token) => buildFieldPlaceholder(token),
  manual: (labelKeyOrText) => buildManualPlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
  optional: (labelKeyOrText) => buildOptionalPlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
  table: (labelKeyOrText) => buildTablePlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
  map: (labelKeyOrText) => buildMapPlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
  image: (labelKeyOrText) => buildImagePlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
  chart: (labelKeyOrText) => buildChartPlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
  caption: (labelKeyOrText) => buildCaptionPlaceholder(
    typeof labelKeyOrText === 'string' ? labelKeyOrText : t(labelKeyOrText)
  ),
});
